import List from "@mui/material/List";
import { styled } from "@mui/material/styles";
import ListItemButton from "components/ui/atoms/ListItemButton";
import NoteListItem from "models/notes/NoteListItem";

const StyledListItemButton = styled(ListItemButton)({
  alignItems: "flex-start",
});

const NoteHits = ({ hits, refresh, onClick }) => {
  return (
    <>
      {hits.length > 0 && (
        <List>
          {hits.map((hit, index) => (
            <StyledListItemButton
              key={`note_list_button_${index}`}
              onClick={() => {
                onClick(hit.id);
              }}
            >
              <NoteListItem note={hit} />
            </StyledListItemButton>
          ))}
        </List>
      )}
    </>
  );
};

export default NoteHits;
